import { createApp } from 'vue/dist/vue.esm-bundler.js';
import Grid from './components/grid';
import Filter from './components/filter';

const app = createApp({
  data() {
    return {
      products: window.products.products,
      videoMp4: window.products.videoMp4,
      videoWebm: window.products.videoWebm,
      poster: window.products.poster,
      testimonial: window.products.testimonial,
      filter: window.products.filter,
      labels: window.products.labels,
      videoPosition: 3,
      testimonialPosition: 8,
      itemsPerPage: 12,
      currentPage: 1,
      mobileFilterVisible: false,
    }
  },
  computed: {
    filteredProducts() {
      if (!this.filterActive) {
        return this.products;
      }

      return Object.values(this.products).filter((product) => {
        const filterResult = {};
        Object.keys(this.filter).forEach((filterGroup) => {
          Object.values(this.filter[filterGroup]).forEach((filterItem) => {
            if (filterItem.active) {
              if (typeof filterResult[filterGroup] === 'undefined') {
                filterResult[filterGroup] = [];
              }
              filterResult[filterGroup].push(product[filterGroup].includes(filterItem.key));
            }
          });
        });

        return Object.values(filterResult).reduce((carry, group) => {
          return carry && group.includes(true);
        }, true);
      });
    },
    finalProducts() {
      const productsCopy = this.filteredProducts.slice(0, this.currentPage * this.itemsPerPage);

      if (this.filterActive) {
        return productsCopy;
      }

      if ((this.videoMp4 || this.videoWebm) && this.products.length > this.videoPosition) {
        productsCopy.splice(this.videoPosition, 0, {type: 'video', mp4: this.videoMp4, webm: this.videoWebm, poster: this.poster});
      }
      if (this.testimonial && this.products.length > this.testimonialPosition) {
        productsCopy.splice(this.testimonialPosition, 0, {type: 'testimonial', testimonial: this.testimonial});
      }

      return productsCopy;
    },
    showMoreButtonVisible() {
      return this.filteredProducts.length > this.currentPage * this.itemsPerPage;
    },
    filterActive() {
      let active = false;
      Object.values(this.filter).forEach((filterGroup) => {
        Object.values(filterGroup).forEach((filterItem) => {
          if (filterItem.active) {
            active = true;
          }
        });
      });
      return active;
    },
  },
  methods: {
    showMore() {
      this.currentPage += 1;
    },
    resetFilter() {
      Object.values(this.filter).forEach((filterGroup) => {
        Object.values(filterGroup).forEach((filterItem) => {
          filterItem.active = false;
        });
      });
      this.currentPage = 1;
    },
    breadCrumb() {
      const breadcrumb = document.getElementById('breadcrumb');
      return breadcrumb.innerHTML;
    },
    openMobileFilter() {
      this.mobileFilterVisible = true;
      document.body.classList.add('overflow-hidden');
    },
    closeMobileFilter() {
      this.mobileFilterVisible = false;
      document.body.classList.remove('overflow-hidden');
    },
  },
  template: `
    <section class="pb-2 pb-lg-4 pb-xl-6 pb-xxl-8">
      <header class="mt-2 my-lg-3">
        <span v-html="breadCrumb()"></span>
        <div class="d-flex justify-content-between mb-1">
          <h4 class="m-0">{{ labels.title }} <small class="text-muted-light fw-bolder fs-xs">{{ filteredProducts.length }} {{ labels.products }}</small></h4>
          <button @click.prevent="openMobileFilter" id="btn-toggle-filter" class="btn btn-transparent d-xl-none btn-toggle-filter"><i class="las la-sliders-h"></i></button>
        </div>
        <hr>
      </header>
      <div class="row">
        <Filter @close-mobile-filter="closeMobileFilter" :filter="filter" :labels="labels" :filter-active="filterActive" :reset-filter="resetFilter" :product-number="filteredProducts.length" :mobile-filter-visible="mobileFilterVisible"></Filter>
        <Grid :products="finalProducts" :labels="labels" :show-more-button-visible="showMoreButtonVisible" :show-more="showMore"></Grid>
      </div>
    </section>
  `
});

app.component('Grid', Grid);
app.component('Filter', Filter);
app.mount('#app');
